module.exports = __webpack_public_path__ + "static/media/header_search.db6510cf.svg";